import styled from "styled-components";

export const Box2 = styled.div`
  .interDisplay {
    font-family: InterDisplay;
  }
  .responsiveRichTextbox {
    height: 42rem;
  }
  .responsiveRichTextbox.quill .ql-editor {
    min-height: 41rem;
    max-height: 41rem;
  }
  @media (max-width: 991px) {
    .responsiveRichTextbox {
      height: 18rem;
    }
    .responsiveRichTextbox.quill .ql-editor {
      min-height: 17rem;
      max-height: 17rem;
    }
    .mBottom1 {
      margin-bottom: 0.5rem;
    }
  }
  @media (max-width: 768px) {
    .responsive768 {
      margin-top: 1rem;
    }
  }
  @media (max-width: 800px) {
  }
  @media (max-width: 768px) {
  }
`;
